import { memberWorkAreas } from '@featit/shared/guest-work-area';
import type { IProject } from '@featit/shared/types/index';
import { findWorkAreaByRouteRef } from '@/routing/workAreaRoute';

/**
 * F-0774 (`docs/concept-settings-navigation.md`): which work area Settings' work-area group is about.
 * Plain, with no section in it, so the shell's tab title (`Layout`) reads it without loading the
 * settings screens.
 */
/**
 * ONE-17 (I-2494): the work area the group shows while a global section is open. Not `workArea`,
 * which says the open section is the work area's (four section ids exist in both scopes).
 */
export const KEPT_WORK_AREA_PARAM = 'inWorkArea';

export interface ISettingsWorkAreaChoice {
  /** The work areas whose settings the reader may read: a guest's are never listed (ONE-6). */
  choices: IProject[];
  /**
   * The group's work area: the address's, else the one a global section kept (`inWorkArea`, ONE-17),
   * else the one the reader is in, else their first.
   */
  chosen: IProject | undefined;
  /** Whether the address names one, which opens the group (ONE-3, ONE-4). */
  named: boolean;
}

export function settingsWorkAreaChoice(
  projects: readonly IProject[],
  selectedProjectId: string | null | undefined,
  searchParams: URLSearchParams,
): ISettingsWorkAreaChoice {
  const choices = memberWorkAreas(projects);
  const askedRef = searchParams.get('workArea');
  const asked = askedRef ? findWorkAreaByRouteRef(choices, askedRef) : undefined;
  const keptRef = searchParams.get(KEPT_WORK_AREA_PARAM);
  const kept = keptRef ? findWorkAreaByRouteRef(choices, keptRef) : undefined;
  const selected = choices.find((each) => each.id === selectedProjectId);
  return { choices, chosen: asked ?? kept ?? selected ?? choices[0], named: Boolean(askedRef) };
}

/**
 * ONE-8: the work area whose settings are open on Settings, or null on a global section, so the
 * heading and the tab title name what the reader is changing.
 */
export function openSettingsWorkArea(
  projects: readonly IProject[],
  selectedProjectId: string | null | undefined,
  searchParams: URLSearchParams,
): IProject | null {
  const { chosen, named } = settingsWorkAreaChoice(projects, selectedProjectId, searchParams);
  return named && chosen ? chosen : null;
}
